import Swal from 'sweetalert2';

import '@css/components/swal.scss';

export default Swal;
